import classNames from 'classnames'
import { ErrorMessage, useField } from 'formik'
import { isEmpty } from 'lodash'

const TextBox = ({ field, ...props }) => {
  const {
    className,
    label,
    maxLength = null,
    minValue,
    readonly = false,
    required = false,
    showValidationErrors,
    textarea = false,
    type = 'text',
    percentage = false,
    wrapperClassName,
    disabled,
  } = props
  const isFirefox = typeof InstallTrigger !== 'undefined'

  // this is in case when we don't use formik
  let name, onChange, value
  if (!isEmpty(field)) {
    name = field.name
    onChange = field.onChange
    value = field.value
  } else {
    name = props.name
    onChange = props.onChange
    value = props.value
  }

  const [textBoxField, textBoxFieldMeta, textBoxHelpers] =
    useField(name)

  const positiveValue =
    value && Math.abs(value) >= 0 && Math.abs(value)

  let textInput = (
    <>
      <input
        className={classNames('textbox__input', className)}
        maxLength={maxLength}
        name={name}
        onChange={onChange}
        readOnly={readonly}
        required={required}
        type={type}
        value={value ?? ''}
        placeholder={isFirefox ? '' : '#'}
        disabled={disabled}
      />
    </>
  )
  if (label) {
    textInput = (
      <div
        className={classNames('textbox', wrapperClassName, {
          '-error':
            showValidationErrors &&
            textBoxFieldMeta.error !== undefined,
          '-required': required,
        })}
      >
        {textInput}
        <label className="textbox__label">{label}</label>
        {showValidationErrors && textBoxFieldMeta.error ? (
          <div className="textbox__error-msg">
            {textBoxFieldMeta.error}
          </div>
        ) : null}
      </div>
    )
  }

  if (textarea) {
    textInput = (
      <>
        <textarea
          className={classNames(
            'textbox__input',
            '-textarea',
            className
          )}
          name={name}
          onChange={onChange}
          readOnly={readonly}
          rows="4"
          type={type}
          value={Math.abs(value) ?? ''}
        />
        <span className="textbox__label">{label}</span>
      </>
    )
  }
  if (type === 'number') {
    textInput = (
      <div
        className={classNames('textbox', wrapperClassName, {
          '-error':
            showValidationErrors &&
            textBoxFieldMeta.error !== undefined,
          '-required': required,
        })}
      >
        <input
          className={classNames(
            'textbox__input',
            '-number-type',
            className
          )}
          maxLength={maxLength}
          min={minValue ?? 0}
          name={name}
          onChange={onChange}
          required={required}
          type={type}
          value={positiveValue}
          placeholder={isFirefox ? '' : '#'}
          step="0.1"
          readOnly={readonly}
        />
        <label className="textbox__label">{label}</label>
        {required && (
          <ErrorMessage
            className="-error"
            component="span"
            name={name}
          />
        )}
      </div>
    )
  }

  if (percentage) {
    textInput = (
      <div
        className={classNames(
          'textbox',
          '-percentage',
          wrapperClassName,
          {
            '-error':
              showValidationErrors &&
              textBoxFieldMeta.error !== undefined,
          }
        )}
        data-value={value}
      >
        <input
          className={classNames(
            'textbox__input -label-active',
            className
          )}
          onKeyPress={(e) =>
            !/[0-9.,]/.test(e.key) && e.preventDefault()
          }
          maxLength={maxLength}
          min={minValue ?? 0}
          name={name}
          onChange={onChange}
          required={required}
          type="text"
          value={value}
          placeholder="%"
          step="0.01"
        />
        <label className="textbox__label">{label}</label>
        {showValidationErrors && textBoxFieldMeta.error ? (
          <div className="textbox__error-msg">
            {textBoxFieldMeta.error}
          </div>
        ) : null}
      </div>
    )
  }

  return textInput
}

export default TextBox
